import { numberParser } from '../inboundParsers';
export const LAST_CHIP_STACK_INBOUND_DEFINITION = {
    definitionParts: [{ name: 'lastChipStack', parser: numberParser }]
};
